var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "patient-icon",
    transform: "translate(8.4 8.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1275",
    "data-name": "Rectangle 1275",
    width: 56,
    height: 56,
    rx: 8,
    transform: "translate(-8.4 -8.4)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M4,35.3a13.067,13.067,0,0,1,26.133,0H26.867a9.8,9.8,0,0,0-19.6,0ZM17.067,20.6a9.8,9.8,0,1,1,9.8-9.8A9.8,9.8,0,0,1,17.067,20.6Zm0-3.267A6.533,6.533,0,1,0,10.533,10.8,6.532,6.532,0,0,0,17.067,17.333Z",
    transform: "translate(2.533 0.633)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientIcon);
export default __webpack_public_path__ + "static/media/patient-icon.6e5502a88e1254380712c5c7ced44ae6.svg";
export { ForwardRef as ReactComponent };